import { IndexRoute, Route, RouteGroup } from '@shared/router';

import { RequireSession } from '@portal/views/_shared/require-session';
import DocumentationPage from '@portal/views/docs';
import KeysPage from '@portal/views/keys';
import CreateKeyPage from '@portal/views/keys/create';
import KeyPage from '@portal/views/keys/detail';
import EditAccessPage from '@portal/views/keys/edit-access';
import RevokeKeyPage from '@portal/views/keys/revoke';
import RotateKeyPage from '@portal/views/keys/rotate';
import LandingPage from '@portal/views/landing';
import LoginPage from '@portal/views/login';
import OrganizationsPage from '@portal/views/organizations';

const routes = [
	<IndexRoute name="home" component={LandingPage} />,

	<Route path="docs/:pagePath*" name="docs" component={DocumentationPage} />,
	<Route
		path="reference/:pagePath*"
		name="reference"
		component={DocumentationPage}
	/>,

	<Route path="login" name="login" component={LoginPage} />,
	<Route
		path="organizations"
		name="organizations"
		component={OrganizationsPage}
	/>,

	/*
	 *	`wrapWith` on the group reaches every child as `wrapGroupWith`, so the
	 *	guard renders once per route and the view below it never mounts — and
	 *	so never fetches — until the session is known. It only works one level
	 *	deep, which is why each path is written out in full rather than nested.
	 *
	 *	Static paths come before `:key`: the delegator matches with `.find()`,
	 *	so the first declaration that fits wins.
	 */
	<RouteGroup name="session" wrapWith={RequireSession}>
		<Route path="keys" name="keys" component={KeysPage} />
		<Route path="keys/new" name="keyCreate" component={CreateKeyPage} />
		{/*
		 *	`:key`, not `:id`: the route generator types a param named `id` or
		 *	ending in `Id` as a number, and a key id is a uuid. Named `key`
		 *	rather than `keys.show`, because `keys` is already a leaf and the
		 *	generator throws on that collision.
		 */}
		<Route path="keys/:key" name="key" component={KeyPage} />
		<Route
			path="keys/:key/access"
			name="keyAccess"
			component={EditAccessPage}
		/>
		<Route path="keys/:key/rotate" name="keyRotate" component={RotateKeyPage} />
		<Route path="keys/:key/revoke" name="keyRevoke" component={RevokeKeyPage} />
	</RouteGroup>,
];

export default routes;
